module.exports = __webpack_public_path__ + "static/media/banner.3a9de669.jpg";